import { SiteSection, useUiStore } from '@/store/ui-store';
import { useUsersStore } from '@/store/users-store';
import { computed } from 'vue';

export function useRoles() {
  const usersStore = useUsersStore();
  const uiStore = useUiStore();

  const actsAsStaff = computed(
    (): boolean =>
      usersStore.isStaffOrMore && uiStore.siteSection === SiteSection.ADMIN,
  );

  return {
    isAdmin: computed((): boolean => usersStore.isAdmin),
    isStaff: computed((): boolean => usersStore.isStaff),
    isStaffOrMore: computed((): boolean => usersStore.isStaffOrMore),
    isCustomerOrMore: computed((): boolean => usersStore.isCustomerOrMore),
    isCustomer: computed((): boolean => usersStore.isCustomer),
    isGuest: computed((): boolean => usersStore.isGuest),
    isFromLPittet: computed((): boolean => usersStore.isFromLPittet),
    actsAsStaff,
    actsAsCustomer: computed(
      (): boolean => usersStore.isCustomerOrMore && !actsAsStaff.value,
    ),
  };
}
